import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const GoogleAuthCallback = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // ✅ Parse URL query parameters
    const urlParams = new URLSearchParams(window.location.search);
    const success = urlParams.get("success");
    const token = urlParams.get("token");
    const user = urlParams.get("user");

    console.log("Google Login Response:", { success, token, user });

    if (success === "true" && token && user) {
      sessionStorage.setItem("accessToken", token);
      sessionStorage.setItem("user", decodeURIComponent(user));

      console.log("User Data:", decodeURIComponent(user));

      // ✅ Redirect to home page
      navigate("/home");
    } else {
      console.error("Google Login Failed");
      navigate("/login");
    }
  }, [navigate]);

  return <h2>Processing Google Login...</h2>;
};

export default GoogleAuthCallback;
